<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Kullanıcı Ayarları</h1>
          </div>
          <!-- /.col -->

          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Kullanıcılar</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Kullanıcılar
                <button class="btn btn-primary btn-sm float-right" @click="resetModal"
                  v-if="auth.UserSetting != null && auth.UserSetting.isWrite">
                  <i class="fas fa-plus"> </i> Yeni Kullanıcı
                </button>
                <div class="card-tools" style="margin: 5px 10px">
                  <div class="input-group input-group-sm" style="width: 250px">
                    <input type="text" v-model="search" class="form-control float-right" placeholder="Kullanıcı Ara" />

                    <div class="input-group-append">
                      <button type="button" class="btn btn-default">
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th style="width: 1%">#</th>
                        <th>Kullanıcı Bilgileri</th>
                        <th>Kullanıcı Adı</th>
                        <th>Son Giriş Tarihi</th>
                        <th style="width: 8%" class="text-center" v-if="auth.UserSetting != null && auth.UserSetting.isWrite
                          ">
                          Aktif/Pasif
                        </th>
                        <th style="min-width: 250px" v-if="auth.UserSetting != null && auth.UserSetting.isWrite
                          "></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in filtered" :key="item.id">
                        <td>#</td>
                        <td>
                          <a> {{ item.name }} {{ item.surname }} </a>
                          <br />
                          <small><b> Unvan :</b>
                            {{ item.isAdmin ? "Yönetici" : "Personel" }}
                          </small>
                        </td>
                        <td>{{ item.username }}</td>
                        <td>{{ item.loginDate | DateFormat }}</td>

                        <td class="project-state" v-if="auth.UserSetting != null && auth.UserSetting.isWrite
                          ">
                          <button class="btn btn-sm btn-block btn-outline-primary" :class="{
                            'btn-outline-success': item.isActive,
                            'btn-outline-danger': !item.isActive,
                          }" @click="status(item.id, !item.isActive)">
                            {{ item.isActive ? "Aktif" : "Pafis" }}
                          </button>
                        </td>
                        <td class="project-actions text-right" v-if="auth.UserSetting != null && auth.UserSetting.isWrite
                          ">
                          <router-link tag="button" :to="'/users/authority/' + item.id"
                            class="btn btn-outline-primary btn-sm" v-if="!item.isAdmin">
                            <i class="fas fa-folder"> </i>
                            Yetkiler
                          </router-link>
                          <button class="btn btn-outline-warning btn-sm" @click="PasswordRestModal(item.id)">
                            <i class="fas fa-lock"> </i>
                          </button>
                          <button class="btn btn-outline-info btn-sm" @click="getModal(item)">
                            <i class="fas fa-pencil-alt"> </i>
                          </button>
                          <button class="btn btn-outline-secondary btn-sm" @click="getModalQr(item)">
                            <i class="fas fa-qrcode"> </i>
                          </button>
                          <button class="btn btn-outline-danger btn-sm" @click="del(item.id)">
                            <i class="fas fa-trash"> </i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="datatable.length == 0" colspan="6" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <!--Modal-->
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Kullancı {{ user.id ? "Düzenleme" : "Ekleme" }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Personel Adı</label>
                <input @blur="$v.user.name.$touch()" v-model="$v.user.name.$model" type="text" class="form-control"
                  :class="{ 'is-invalid': $v.user.name.$error }" placeholder="Personel adını giriniz" />
                <small v-if="!$v.user.name.required && $v.user.name.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
              <div class="form-group">
                <label>Personel Soyadı</label>
                <input @blur="$v.user.surname.$touch()" v-model="$v.user.surname.$model" type="text" class="form-control"
                  :class="{ 'is-invalid': $v.user.surname.$error }" placeholder="Personel soyadını giriniz" />
                <small v-if="!$v.user.surname.required && $v.user.surname.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
              <div class="form-group">
                <label>Kullancı Adı</label>
                <input @blur="$v.user.username.$touch()" v-model="$v.user.username.$model" type="text"
                  class="form-control" :class="{ 'is-invalid': $v.user.username.$error }"
                  placeholder="Kullanıcı adını giriniz" />
                <small v-if="!$v.user.username.required && $v.user.username.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Şifre</label>
                <input v-model="$v.user.password.$model" type="password" class="form-control"
                  placeholder="Şifrenizi giriniz" />

                <small v-if="!$v.user.password.required && $v.user.password.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
                <small v-if="!$v.user.password.minLength && $v.user.password.$error" class="form-text text-danger">Lütfen
                  şifreniz en az
                  {{ $v.user.password.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.password.maxLength && $v.user.password.$error" class="form-text text-danger">Lütfen
                  şifreniz en fazla
                  {{ $v.user.password.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Şifre Tekrar</label>
                <input v-model="$v.user.repassword.$model" type="password" class="form-control"
                  placeholder="Şifrenizi tekrar giriniz" />
                <small v-if="!$v.user.repassword.required && $v.user.repassword.$error
                  " class="form-text text-danger">Bu alan zorunludur...
                </small>

                <small v-if="!$v.user.repassword.minLength && $v.user.repassword.$error
                  " class="form-text text-danger">Lütfen şifreniz en az
                  {{ $v.user.repassword.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.repassword.maxLength && $v.user.repassword.$error
                  " class="form-text text-danger">Lütfen şifreniz en fazla
                  {{ $v.user.repassword.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.repassword.sameAs && $v.user.repassword.$error"
                  class="form-text text-danger">Girdiğiniz şifreler birbirleriyle uyuşmuyor...
                </small>
              </div>
              <div class="form-group">
                <label>Personel Yetkisi</label>
                <select v-model="user.isAdmin" class="form-control">
                  <option :value="null">Lütfen Yetki Seçiniz</option>
                  <option :value="false">Personel</option>
                  <option :value="true">Yönetici</option>
                </select>
                <small class="form-text text-danger">* Yöneticiler tüm sitelere ve işlemlere yetkilidir.<br />*
                  Personellerin site ve işlem yetkilerini
                  <b>yetkiler</b> alanından ayarlamanız gerekmektedir.
                </small>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.user.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modal-qr">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Kullancı Qr Kodu</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img class="img-thumbnail mx-auto d-block" :src="user.qr" />
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="PasswordRestModel">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Şifre Değiştir</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <input type="hidden" id="userId">
              <div class="form-group" v-if="!user.id">
                <label>Yeni Şifre</label>
                <input v-model="$v.user.password.$model" type="password" id="userNewPassword" class="form-control"
                  placeholder="yeni şifreyi girin" />

                <small v-if="!$v.user.password.required && $v.user.password.$error" class="form-text text-danger">Bu
                  alan zorunludur...</small>
                <small v-if="!$v.user.password.minLength && $v.user.password.$error" class="form-text text-danger">Lütfen
                  şifreniz en az
                  {{ $v.user.password.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.password.maxLength && $v.user.password.$error" class="form-text text-danger">Lütfen
                  şifreniz en fazla
                  {{ $v.user.password.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Yeni Şifre Tekrar</label>
                <input v-model="$v.user.repassword.$model" id="userNewRepassword" type="password" class="form-control"
                  placeholder="Yeni şifrenizi tekrar giriniz" />
                <small v-if="!$v.user.repassword.required && $v.user.repassword.$error
                  " class="form-text text-danger">Bu alan zorunludur...
                </small>

                <small v-if="!$v.user.repassword.minLength && $v.user.repassword.$error
                  " class="form-text text-danger">Lütfen şifreniz en az
                  {{ $v.user.repassword.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.repassword.maxLength && $v.user.repassword.$error
                  " class="form-text text-danger">Lütfen şifreniz en fazla
                  {{ $v.user.repassword.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.repassword.sameAs && $v.user.repassword.$error"
                  class="form-text text-danger">Girdiğiniz şifreler birbirleriyle uyuşmuyor...
                </small>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="RestAccount()">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      page: 1,
      perPage: 10,
      rows: 0,
      users: [],
      datatable: [],
      overlay: false,
      search: "",
      user: {
        username: "",
        password: "",
        repassword: "",
        name: "",
        surname: "",
        isAdmin: false,
      },
    };
  },
  validations: {
    user: {
      username: {
        required,
      },
      name: {
        required,
      },
      surname: {
        required,
      },
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
      },
      repassword: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
        sameAs: sameAs("password"),
      },
    },
  },
  methods: {
    getDatas() {
      this.overlay = true;
      this.$http.get("User/ListUsers").then((response) => {
        this.users = response.data;
        this.datatable = this.users.slice(0, this.perPage);
        this.rows = this.users.length;

        this.overlay = false;
      });
    },
    PasswordRestModal(id) {
      var AssignUserid = document.getElementById("userId");
      AssignUserid.value = id;
      document.getElementById("userNewPassword").value = "";
      document.getElementById("userNewRepassword").value = "";
      $("#PasswordRestModel").modal();
    },
    getModal(value) {
      this.user = value;
      this.user.password = 123456;
      this.user.repassword = 123456;

      $("#modal").modal();
    },
    getModalQr(value) {
      this.user = value;

      $("#modal-qr").modal();
    },
    resetModal() {
      this.user = {
        username: "",
        password: "",
        repassword: "",
        name: "",
        surname: "",
        isAdmin: false,
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    save() {
      let url = "User/AddUser";
      if (this.user.id) url = "User/EditUser/" + this.user.id;

      this.$http.post(url, this.user).then((response) => {
        toastr.success("Kayıt başarılı.");
        $("#modal").modal("hide");
        this.getDatas();
      });
    },
    RestAccount() {
      var AdminId = localStorage.getItem("id");
      var userNewPassword = document.getElementById("userNewPassword").value;
      var userId = document.getElementById("userId").value;
      // Check if userNewPassword is empty
      if (!userNewPassword) {
        toastr.warning("Lütfen yeni şifre giriniz.");
        return; 
      }
      this.$http.post("User/RestPassword/?AdminId=" + AdminId + "&userNewPassword=" + userNewPassword + "&userId=" + userId)
        .then(
          (response) => {
            toastr.success("Şifre başarıyla sıfırlandı.");
            $("#PasswordRestModel").modal("hide");
            this.getDatas();
          },
          (err) => {
            console.log(err);
          }
        );
    },
    status(id, status) {
      this.$http
        .get("User/ChangeStatus/" + id + "?status=" + status)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getDatas();
        });
    },
    del(id) {
      Swal.fire({
        title: "Kayıt kalıcı olarak silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http.get("User/DeleteUser/" + id).then(
            (response) => {
              toastr.success("Kayıt başarıyla silindi.");
              this.getDatas();
            },
            (error) => {
              toastr.error(error.data.Message);
            }
          );
        }
      });

      return;
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  computed: {
    filtered() {
      var count = (this.page - 1) * this.perPage;

      let datas = this.users.filter((value) => {
        return value.username.toLowerCase().match(this.search.toLowerCase());
      });
      this.rows = datas.length;

      return datas.slice(count, count + this.perPage);
    },
  },
  created() {
    this.getDatas();
  },
  watch: {
    search() {
      this.page = 1;
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/User/UserList.vue